.pageLoaderContainer {
  position: fixed;
  height: 100vh;
  width: 100vw;
  background: var(--static-background-standard);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.boxemLogoContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex-direction: column;
  gap: 1rem;
}

.textLogo {
  position: absolute;
  min-width: max-content;
  clip-path: xywh(0 0 2.1rem 100%);
  color: var(--static-text-strong);
  z-index: 2;
  right: -158px;
  width: 117px;
  height: 26px;
}

.spinner {
  position: absolute;
  z-index: 1;
}